import type { FieldOption } from "shared"

/**
 * A value for the next option: `option-N` for the next place in the list,
 * stepping past any value already taken, since a value is an option's
 * identity and two options cannot share one.
 */
export function nextOptionValue(options: ReadonlyArray<FieldOption>): string {
  const taken = new Set(options.map((option) => option.value))
  let n = options.length + 1
  while (taken.has(`option-${n}`)) n++
  return `option-${n}`
}
